import { CertificadoService } from '../../services/certificado.service';
import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as forge from 'node-forge';
import { arrayBufferToString } from '../../util/format';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-certificado-revogar',
  templateUrl: './modal-certificado-revogar.component.html',
  styleUrls: ['./modal-certificado-revogar.component.scss'],
})
export class ModalCertificadoRevogarComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() identificador: string;
  @Output() fecharModal = new EventEmitter();

  form: FormGroup = this.formBuilder.group({
    token: new FormControl(null, Validators.required),
    chave: new FormControl(null, Validators.required),
  });

  fileReader = new FileReader();

  constructor(
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private loading: NgxSpinnerService,
    private certificadoService: CertificadoService
  ) {

  }

  ngOnInit() {

  }

  sim() {
    this.loading.show();
    this.certificadoService.listCert(this.identificador).then(
      list => {
        this.certificadoService.revolke(list[0].serialNumber).then(revogado => {
          this.loading.hide();
          console.log('revogado', revogado);
          this.fechar(true);
        }).catch(err => {
          this.loading.hide();
          this.toast.error(err.error.message);
        });
      }).catch(err => {
        this.loading.hide();
        this.toast.error(err.error.message);
      });
  }

  nao() {
    this.fechar(false);
  }

  fechar(data?) {
    this.fecharModal.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-certificado-revogar/modal-certificado-revogar.component.ts